import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import Combobox from "@/components/Combobox";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";

export default function EntryFields({
  date, setDate, hours, setHours, helper, setHelper, workType, setWorkType,
  helpers, workTypes,
  dateTestId = "entry-date-trigger",
  hoursTestId = "entry-hours-trigger",
  helperTestId = "helper-combobox",
  workTypeTestId = "worktype-combobox",
}) {
  const [dateOpen, setDateOpen] = useState(false);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
      <div className="space-y-2">
        <Label className="text-[#5F6368]">Datum</Label>
        <Popover open={dateOpen} onOpenChange={setDateOpen}>
          <PopoverTrigger asChild>
            <Button type="button" variant="outline" data-testid={dateTestId}
              className="w-full justify-start h-11 bg-white border-[#E2E2E2] font-normal text-[#212529] hover:bg-[#FCE7F3]">
              <CalendarIcon size={16} className="mr-2 text-[#E6017D]" />
              {date ? format(date, "dd.MM.yyyy", { locale: de }) : <span className="text-[#9AA0A6]">Datum wählen</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar mode="single" selected={date} locale={de} initialFocus
              onSelect={(d) => { if (d) { setDate(d); setDateOpen(false); } }} />
          </PopoverContent>
        </Popover>
      </div>

      <div className="space-y-2">
        <Label className="text-[#5F6368]">Anzahl der Stunden</Label>
        <Select value={hours} onValueChange={setHours}>
          <SelectTrigger className="h-11 bg-white border-[#E2E2E2]" data-testid={hoursTestId}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 8 }, (_, i) => String(i + 1)).map((h) => (
              <SelectItem key={h} value={h} data-testid={`${hoursTestId}-option-${h}`}>{h} Std.</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-[#5F6368]">Vorname und Name der Helfer</Label>
        <Combobox
          value={helper}
          onChange={setHelper}
          options={helpers}
          placeholder="Helfer auswählen oder eingeben…"
          searchPlaceholder="Helfer suchen oder neu eingeben…"
          emptyText="Keine gespeicherten Helfer."
          savedHeading="Gespeicherte Helfer"
          testId={helperTestId}
        />
      </div>

      <div className="space-y-2">
        <Label className="text-[#5F6368]">Art der Bauarbeiten</Label>
        <Combobox
          value={workType}
          onChange={setWorkType}
          options={workTypes}
          placeholder="Auswählen oder eingeben…"
          searchPlaceholder="Bauarbeit suchen oder neu eingeben…"
          emptyText="Keine passende Bauarbeit."
          savedHeading="Arten der Bauarbeiten"
          testId={workTypeTestId}
        />
      </div>
    </div>
  );
}
